import React from 'react'
import { Accordion, Button, Container, Row, Card, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import styles from './QISoftware.module.scss';

const WinQIAccordions = () => {
    return (<>

        <Container className="outerContainer">
            <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Software Instructions & Tutorial Video</Accordion.Header>
                    <Accordion.Body>
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>Software Instructions v2021</h4>
                                <p>Software Instructions (WinQI) Version v2021, July 2021.</p>
                            </Col>
                            <Col md={2}>
                                <Button className='mt-3' href="https://www.qualityindicators.ahrq.gov/Downloads/Software/WinQI/V2021/Software_Inst_WINQI_V2021_July_2021.pdf">Download</Button>
                            </Col>
                        </Row>
                        <hr className={styles.divider} />
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>Software Tutorial Video</h4>
                                <p>To learn more about how to use the software, view the WinQI tutorial video.</p>
                            </Col>
                            <Col md={2}>
                            <Button href="https://www.youtube.com/watch?v=-lNnrq5IW2I">
                                View Video
                            </Button>                            
                            </Col>
                        </Row>

                        <hr className={styles.divider} />
                        <Row className={styles.accordionContent}>
                            <h4>Supporting Software</h4>
                            <p>The AHRQ Quality Indicators Windows Application may be installed on 64-bit or 32-bit platforms, and no third-party statistical software is needed. SQL Server and .NET are provided free of charge by Microsoft. For more information please see the following links on the Microsoft website: (this will take you away from the AHRQ website)</p>
                            <p className="ml-4 pl-4">
                                <ul>
                                    <li><a href="https://go.microsoft.com/fwlink/?linkid=866658">Microsoft SQL Server 2019 Express Edition</a><span><Link to="/ExternalDisclaimer"><img alt="external web link policy" style={{marginLeft: 4}} src="/images/exit_disclaimer.png"/></Link></span></li>
                                </ul>
                            </p>

                        </Row>
                    </Accordion.Body>
                </Accordion.Item>
                </Accordion>
                <Accordion>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>Software Release Notes</Accordion.Header>
                    <Accordion.Body>
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>v2021 Software Release Notes</h4>
                                <p>Version v2021, July 2021 - Summary of the high level changes from v2020.0.1 to v2021 of the Technical Specifications and QI Software.</p>
                            </Col>
                            <Col md={2}>
                                <Button  className='mt-3' href="https://www.qualityindicators.ahrq.gov/Downloads/Software/WinQI/V2021/AHRQ_WinQI_v2021_Software_Rel_Notes.pdf">Download</Button>
                            </Col>
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>
                </Accordion>
                <Accordion>
                <Accordion.Item eventKey="2">
                    <Accordion.Header>Additional Software Resources</Accordion.Header>
                    <Accordion.Body>
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>Instructions for Calculating Smoothed Rate Confidence Intervals in WinQI, September 2010</h4>
                                <p>This document provides instructions for using the Excel workbook “Calculating the Smoothed Rate CI in WinQI”</p>
                            </Col>
                            <Col md={2}>
                                <Button className='mt-3' href="https://www.qualityindicators.ahrq.gov/Downloads/Software/WinQI/V41B/Calculating%20the%20Smoothed%20Rate%20CI%20in%20WinQI.pdf">Download</Button>
                            </Col>
                        </Row>
                        <hr className={styles.divider} />
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>Workbook for Calculating the Smoothed Rate Confidence Intervals in WinQI</h4>
                                <p>This workbook helps compute the upper and lower bounds of the smoothed rate confidence intervals in WinQI</p>
                            </Col>
                            <Col md={2}>
                                <Button className='mt-3' href="https://www.qualityindicators.ahrq.gov/Downloads/Software/WinQI/V41B/Calculating%20the%20Smoothed%20Rate%20CI%20in%20WINQI.xls">Download</Button>
                            </Col>
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>
                </Accordion>
                <Accordion>
                <Accordion.Item eventKey="3">
                    <Accordion.Header>Indicator Technical Resources</Accordion.Header>
                    <Accordion.Body>
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>Prevention Quality Indicators (PQI)</h4>
                                <p>PQI Individual Measure Technical Specifications (v2021 ICD-10-CM/PCS coding)</p>
                            </Col>
                            <Col md={2}>
                            <Link
                                    className="btn btn-primary mt-3"
                                    role="button"
                                    to="/measures/PQI_TechSpec_ICD10_v2021"
                                >
                                    Download
                                </Link>
                            </Col>
                        </Row>
                        <hr className={styles.divider} />
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>Inpatient Quality Indicators (IQI)</h4>
                                <p>IQI Individual Measure Technical Specifications (v2021 ICD-10-CM/PCS coding)</p>
                            </Col>
                            <Col md={2}>
                            <Link
                                    className="btn btn-primary mt-3"
                                    role="button"
                                    to="/measures/IQI_TechSpec_ICD10_v2021"
                                >
                                    Download
                                </Link>
                            </Col>
                        </Row>
                        <hr className={styles.divider} />
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>Patient Safety Indicators (PSI)</h4>
                                <p>PSI Individual Measure Technical Specifications (v2021 ICD-10-CM/PCS coding)</p>
                            </Col>
                            <Col md={2}>
                            <Link
                                    className="btn btn-primary mt-3"
                                    role="button"
                                    to="/measures/PSI_TechSpec_ICD10_v2021"
                                >
                                    Download
                                </Link>
                            </Col>
                        </Row>
                        <hr className={styles.divider} />
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>Pediatric Quality Indicator (PDI)</h4>
                                <p>PDI Individual Measure Technical Specifications (v2021 ICD-10-CM/PCS coding)</p>
                            </Col>
                            <Col md={2}>
                            <Link
                                    className="btn btn-primary mt-3"
                                    role="button"
                                    to="/measures/PDI_TechSpec_ICD10_v2021"
                                >
                                    Download
                                </Link>
                            </Col>
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>
                </Accordion>
                <Accordion>
                <Accordion.Item eventKey="4">
                    <Accordion.Header>WinQI Software Archives</Accordion.Header>
                    <Accordion.Body>
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>WinQI v2020.0.1 64-Bit without APR-DRG Grouper, October 2020</h4>
                            </Col>
                            <Col md={2}>
                                <Button className='mt-3' href="https://www.qualityindicators.ahrq.gov/Downloads/Software/WinQI/V2020/quality_indicators_202001_x64_Setup_Without_APR-DRG.zip">Download</Button>
                            </Col>
                        </Row>
                        <hr className={styles.divider} />
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>WinQI v2020.0.1 64-Bit with APR-DRG Grouper, October 2020</h4>
                            </Col>
                            <Col md={2}>
                                <Button className='mt-3' href="https://www.qualityindicators.ahrq.gov/Downloads/Software/WinQI/V2020/quality_indicators_202001_x64_Setup_With_APR-DRG.zip">Download</Button>
                            </Col>
                        </Row>
                        <hr className={styles.divider} />
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>WinQI v2020 ICD-10-CM/PCS 64-Bit without APR-DRG Grouper, July 2020</h4>
                            </Col>
                            <Col md={2}>
                                <Button className='mt-3' href="https://www.qualityindicators.ahrq.gov/Downloads/Software/WinQI/V2020/quality_indicators_2020_x64_Setup_Without_APR-DRG.zip">Download</Button>
                            </Col>
                        </Row>
                        <hr className={styles.divider} />
                        <Row className={styles.accordionContent}>
                            <Col md={10}>
                                <h4>WinQI v2019.0.1 ICD-10-CM/PCS 64-Bit without APR-DRG Grouper, September 2019</h4>
                            </Col>
                            <Col md={2}>
                                <Button className='mt-3' href="https://www.qualityindicators.ahrq.gov/Downloads/Software/WinQI/V2019/quality_indicators_201901_x64_Setup_Without_APR-DRG.zip">Download</Button>
                            </Col>
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
            <Link to="/archive/software?2#WinQI-Software">Get Archived WinQI Software</Link>

        </Container>
    </>)
}

export default WinQIAccordions;